import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';

interface IncentivesTrackerItem {
  branchName: string;
  pledgeNumber: string;
  pledgeStartDate: string | null;
  pledgePrincipal: number;
  agentCode: string;
  accountName: string;
  bankName: string;
  pledgeCloseDate: string | null;
  interestDays: number;
  amountToBePaid: number;
  paymentStatus: 'NOT_PAID' | 'PAID' | 'REJECTED';
}

interface IncentivesTrackerProps {
  data: IncentivesTrackerItem[];
}

const STATUS_COLOR: Record<string, string> = {
  NOT_PAID: 'orange',
  PAID: 'green',
  REJECTED: 'red',
};

const formatDate = (val: string | null) => {
  if (val === null || val === undefined) return '-';
  const d = new Date(val);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const columns: ColumnsType<IncentivesTrackerItem & { _sno: number }> = [
  {
    title: 'S.No',
    dataIndex: '_sno',
    key: '_sno',
    width: 60,
  },
  {
    title: 'Branch',
    dataIndex: 'branchName',
    key: 'branchName',
  },
  {
    title: 'Pledge Number',
    dataIndex: 'pledgeNumber',
    key: 'pledgeNumber',
    render: (val: string) => <strong>{val}</strong>,
  },
  {
    title: 'Pledge Loan Date',
    dataIndex: 'pledgeStartDate',
    key: 'pledgeStartDate',
    render: formatDate,
  },
  {
    title: 'Pledge Amount (₹)',
    dataIndex: 'pledgePrincipal',
    key: 'pledgePrincipal',
    render: (val: number) => `₹${val.toLocaleString('en-IN')}`,
  },
  {
    title: 'Agent Code',
    dataIndex: 'agentCode',
    key: 'agentCode',
  },
  {
    title: 'Account Name',
    dataIndex: 'accountName',
    key: 'accountName',
  },
  {
    title: 'Bank Name',
    dataIndex: 'bankName',
    key: 'bankName',
  },
  {
    title: 'Pledge Close Date',
    dataIndex: 'pledgeCloseDate',
    key: 'pledgeCloseDate',
    render: formatDate,
  },
  {
    title: 'Interest Days',
    dataIndex: 'interestDays',
    key: 'interestDays',
  },
  {
    title: 'Incentive Amount (₹)',
    dataIndex: 'amountToBePaid',
    key: 'amountToBePaid',
    render: (val: number) => `₹${val.toLocaleString('en-IN')}`,
  },
  {
    title: 'Payment Status',
    dataIndex: 'paymentStatus',
    key: 'paymentStatus',
    render: (status: string) => (
      <Tag color={STATUS_COLOR[status] ?? 'default'}>{status.replace('_', ' ')}</Tag>
    ),
  },
];

const IncentivesTrackerDisplay: React.FC<IncentivesTrackerProps> = ({ data }) => {
  const dataWithSno = data.map((item, idx) => ({ ...item, _sno: idx + 1 }));

  return (
    <div className="loan-data-container">
      <h2>Incentives Tracker</h2>
      <Table
        columns={columns}
        dataSource={dataWithSno}
        rowKey="_sno"
        pagination={{ pageSize: 20, showTotal: (t) => `${t} records` }}
        scroll={{ x: true }}
        bordered
      />
    </div>
  );
};

export default IncentivesTrackerDisplay;
